export function timeToMinutes(value: string): number {
  const match = /^(\d{1,2})(?::([0-5]\d))?\s*(AM|PM)?$/i.exec(value.trim());
  if (!match) throw new Error(`Invalid forecast time: ${value}`);
  const hour = Number(match[1]);
  const period = match[3]?.toUpperCase();
  if (hour > (period ? 12 : 23) || (period && hour < 1) || (!period && match[2] === undefined)) {
    throw new Error(`Invalid forecast time: ${value}`);
  }
  return ((period ? hour % 12 + (period === 'PM' ? 12 : 0) : hour) * 60) + Number(match[2] || 0);
}

export function formatForecastTime(value: string): string {
  const minutes = timeToMinutes(value);
  const hour = Math.floor(minutes / 60);
  return `${hour % 12 || 12}:${String(minutes % 60).padStart(2, '0')} ${hour >= 12 ? 'PM' : 'AM'}`;
}
